import React from "react";
import Header from "../../components/header/Header";
import styles from "./ManageCountry.module.css";
import PageHeading from "../../components/PageHeading/PageHeading";
import {
  useGetLocationsListQuery,
  useUpdateLocationStatusMutation,
} from "../../store/api/settingsApi";
import { useToast } from "../../hooks/useToast";

const ManageCountry: React.FC = () => {
  const { data: locationsData, isLoading } = useGetLocationsListQuery(1);
  const [updateLocation] = useUpdateLocationStatusMutation();
  const { showToast } = useToast();

  const handleToggle = async (locationId: number, isDelete: boolean) => {
    try {
      await updateLocation({
        locationId,
        isDisable: !isDelete,
      }).unwrap();
      showToast("Location status updated successfully", "success");
    } catch (error) {
      showToast("Failed to update location status", "error");
    }
  };

  return (
    <div className={styles.container}>
      <Header />
      <div className={styles.mainContent}>
        <PageHeading title="Manage Country" />
        <div className={styles.grid}>
          {isLoading ? (
            <div>Loading...</div>
          ) : (
            locationsData?.data.map((location) => (
              <label key={location.id} className={styles.countryItem}>
                <input
                  type="checkbox"
                  checked={!location.is_delete}
                  onChange={() => handleToggle(location.id, location.is_delete)}
                />
                <span>{location.name}</span>
              </label>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default ManageCountry;
